export default __webpack_public_path__ + "media/images/portrait/small/avatar-s-18-8dcb8f8a0afe3ba41823ed6f81c4ebd8.png";